import styled from "styled-components";
import { Link } from "react-router-dom";
import { dispositivo } from "../Dispositivos";

export const ContenedorHeader = styled.div`
  position: relative;
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px; /* Añade padding lateral */
  overflow: visible; /* Permite que el dropdown se muestre fuera */

  @media (max-width: 768px) {
    padding: 5px 10px;
  }

  /* Estilos específicos para el wrapper de notificaciones */
  .notification-wrapper {
    position: relative;
    display: inline-block;
  }
`;

export const HeaderBar = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const HeaderFigure = styled.figure`
  align-content: center;
  justify-content: flex-start;
  float: left;
`;

export const HeaderBarUl = styled.ul`
  display: flex;
  gap: 10px;
  list-style: none;
  width: 100%;
  justify-content: flex-end;
  margin-bottom: 0;
  align-items: center;
`;

export const HeaderBarLi = styled.li`
  border-bottom: none;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  @media ${dispositivo.mobileL} {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const HeaderBarLink = styled(Link)`
  color: #fff;
  font-size: 13px;

  @media ${dispositivo.mobileL} {
    font-size: 14px;
  }
  @media ${dispositivo.tablet} {
    font-size: 16px;
  }
`;

export const HeaderPlanInfo = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderPlanToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 0.78rem;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover,
  &:focus {
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 255, 255, 0.28);
    outline: none;
  }
`;

export const HeaderPlanBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 0.72rem;
  text-transform: uppercase;
`;

export const HeaderPlanMenu = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 180px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(60, 66, 87, 0.12);
  z-index: 50;
  overflow: hidden;
`;

export const HeaderPlanMenuItem = styled(Link)`
  display: block;
  width: 100%;
  padding: 10px 14px;
  color: #1f2937;
  font-size: 0.9rem;
  text-decoration: none;
  transition: background 0.2s ease;

  &:hover {
    background: #f8fafc;
    color: #0c8de3;
  }
`;

export const HeaderBarSpan = styled.span`
  color: #fff;
  font-size: 13px;
  &:hover {
    text-decoration: underline;
  }
  @media ${dispositivo.mobileL} {
    font-size: 14px;
  }
  @media ${dispositivo.tablet} {
    font-size: 16px;
  }
`;
